import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CallService } from './call.service';

const service = new CallService();

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CallState {}

const CallStore: Module<CallState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async call(
         context,
         {
            candidateId,
            hitId,
            phoneNumber,
            preventVoicemail,
         }: { candidateId: number; hitId?: number; phoneNumber?: string; preventVoicemail?: boolean },
      ) {
         const response = await service.callCandidate(candidateId, hitId, phoneNumber, preventVoicemail);
         return response.data;
      },
   },
};

export default CallStore;
